export const SITE_URL = "https://zhivarus.ru";
export const SITE_NAME = "FARMASVET — ЖИВАРУС";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const DEFAULT_LOCALE = "ru_RU";
export const DEFAULT_AUTHOR = "FARMASVET";

export const DEFAULT_TITLE =
  "ЖИВАРУС — натуральный биопрепарат из 300+ компонентов | FARMASVET";
export const DEFAULT_DESCRIPTION =
  "ЖИВАРУС — двухкомпонентная система от FARMASVET: 300+ растительных компонентов, фуллерены C₆₀ и антимикробный биощит. Купить от 4 900 ₽ с доставкой по России.";
